import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import SectionHeader from '../../Form/Fields/SectionHeader';
import SelectField from '../../Form/Fields/SelectField';
import TextField from '../../Form/Fields/TextField';
import UnitTextField from '../../Form/Fields/UnitTextField';
import { getLanguage, getConfigs } from '../../../features/app/selectors';

// import { getTimeUnitsTranslated } from '../../../features/app/timeUnitSelectors';
// import { getTemperatureUnits } from '../../../features/app/temperatureUnitSelectors';
import { getProductionsTranslated } from '../../../features/app/productionSelectors';
import { getStockHierarchyTranslated } from '../../../features/app/stockHierarchySelectors';

function buildOptionsFromConfig(configItems) {
  return configItems.map(({ code, name }) => ({
    value: code,
    label: name
  }));
}

const KeyParamsTabContent = () => {
  const language = useSelector(getLanguage);
  const stockHierarchy = useSelector(getStockHierarchyTranslated).toJS();
  const productionCodes = useSelector(getProductionsTranslated).toJS();
  // const timeUnits = useSelector(getTimeUnitsTranslated).toJS();
  const getConfigData = useSelector(getConfigs).toJS();

  // const temperatureUnits = useSelector(getTemperatureUnits).toJS();
  const tempUnitForDropDown = [];
  getConfigData &&
    getConfigData.temperatureUnits.map(item => {
      const obj = {};
      obj.code = item.code;
      obj.slug = item.info[language].slug;
      obj.text = item.info[language].text;
      obj.textShort = item.info[language].textShort;
      tempUnitForDropDown.push(obj);
    });

  const timeUnitForDropDown = [];
  getConfigData &&
    getConfigData.timeUnits.map(item => {
      const obj = {};
      obj.code = item.code;
      obj.ratio = item.ratio;
      obj.slug = item.info[language].slug;
      obj.text = item.info[language].text;
      obj.textShort = item.info[language].textShort;
      timeUnitForDropDown.push(obj);
    });
  const shelfLifeUnitForDropDown = [];
  getConfigData &&
    getConfigData.shelfLifeTimeUnits.map(item => {
      const obj = {};
      obj.code = item.code;
      obj.ratio = item.ratio;
      obj.slug = item.info[language].slug;
      obj.text = item.info[language].text;
      obj.textShort = item.info[language].textShort;
      shelfLifeUnitForDropDown.push(obj);
    });

  const firstStorageOptions = buildOptionsFromConfig(stockHierarchy);
  const sortedFirstStorageOptions = _.sortBy(firstStorageOptions, `label`);
  const productionCodeOptions = buildOptionsFromConfig(productionCodes);
  // console.log("productionCodeOptions",productionCodeOptions,firstStorageOptions,sortedFirstStorageOptions)
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <SectionHeader translationId="ppi.preparationHeader" />
        <Grid container spacing={2}>
          <Grid item sm={6} md={3}>
            <SelectField
              label="ppi.preparationFirstStorageLabel"
              dataField="firstStorage"
              helperText="ppi.preparationFirstStorageHelperText"
              items={sortedFirstStorageOptions}
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <TextField
              label="ppi.preparationActionLabel"
              dataField={`info.${language}.preparationAction`}
              helperText="ppi.preparationActionHelperText"
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppi.preparationTimeLabel"
              dataField="preparationTime"
              helperText="ppi.preparationTimeHelperText"
              units={timeUnitForDropDown}
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppi.preparationSecondShelfLifeLabel"
              dataField={`info.${language}.secondShelfLife`}
              helperText="ppi.preparationSecondShelfLifeHelperText"
              units={shelfLifeUnitForDropDown}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SectionHeader translationId="ppi.productionHeader" />
        <Grid container spacing={2}>
          <Grid item sm={6} md={3}>
            <SelectField
              label="ppi.productionProduction"
              dataField="production"
              helperText="ppi.productionProductionHelperText"
              items={productionCodeOptions}
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <TextField
              label="ppi.productionExtra"
              dataField={`info.${language}.productionExtra`}
              helperText="ppi.productionExtraHelperText"
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppi.productionTime"
              dataField="productionTime"
              helperText="ppi.productionTimeHelperText"
              units={timeUnitForDropDown}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SectionHeader translationId="ppi.servingHeader" />
        <Grid container spacing={2}>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppi.servingHoldingTemp"
              dataField="servingHoldingTemp"
              helperText="ppi.servingHoldingTempHelperText"
              units={tempUnitForDropDown}
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppi.servingHoldingTime"
              dataField={`info.${language}.servingHoldingTime`}
              helperText="ppi.servingHoldingTimeHelperText"
              units={timeUnitForDropDown}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default KeyParamsTabContent;
